(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfValidate', [
    '$compile', '$templateCache', function($compile, $templateCache) {
      return {
        require: 'mfValidate',
        controller: [
          '$scope', '$http', '$q', '$interpolate', function($scope, $http, $q, $interpolate) {
            return {
              save: function(setAllDirty, params) {
                var pretending, promise, saveFn;
                if (setAllDirty == null) {
                  setAllDirty = true;
                }
                if (params == null) {
                  params = [];
                }
                saveFn = $scope.$eval(this.element.attr('mf-validate'));
                pretending = $http.defaults.headers.common['PretendValidate'];
                params = [pretending != null].concat(params);
                promise = saveFn.apply($scope, params);
                if (typeof (promise != null ? promise.then : void 0) !== 'function') {
                  return;
                }
                return promise["finally"](function(response) {
                  var name, object, ref;
                  ref = $scope.$validation;
                  for (name in ref) {
                    object = ref[name];
                    object.$errors = [];
                    object.$invalid = false;
                  }
                })["catch"](function(response) {
                  var errors, name, ref, ref1, ref2;
                  if (response.status === 422) {
                    ref = response.data;
                    for (name in ref) {
                      errors = ref[name];
                      if ((ref1 = $scope.$validation[name]) != null) {
                        ref1.$errors = errors;
                      }
                      if ((ref2 = $scope.$validation[name]) != null) {
                        ref2.$invalid = true;
                      }
                    }
                    return $q.resolve();
                  }
                  return $q.reject(response);
                })["finally"]((function(_this) {
                  return function() {
                    var name, object, ref, ref1;
                    if (setAllDirty) {
                      ref = $scope.$validation;
                      for (name in ref) {
                        object = ref[name];
                        object.$dirty = true;
                      }
                    }
                    ref1 = $scope.$validation;
                    for (name in ref1) {
                      object = ref1[name];
                      _this.markElementValidity(object);
                    }
                  };
                })(this))["catch"](function(error) {
                  if (error !== 'cancel') {
                    throw error;
                  }
                });
              },
              markElementValidity: function(validationObject) {
                var input;
                input = this.element.find("[mf-validate-uid=" + validationObject.$uid + "]").find('[mf-validate-repeat],[mf-validate-model]');
                if (input.hasClass('ui-select-container')) {
                  input = input.find('a');
                } else if (input.parents('.nav-tabs').length > 0) {
                  input = input.closest('a');
                }
                if (validationObject.$invalid) {
                  if (validationObject.$dirty) {
                    input.addClass('mfvalidate-invalid');
                  }
                  if (!validationObject.$isGroup) {
                    return this.markGroupsInvalid(input, validationObject);
                  }
                } else {
                  return input.removeClass('mfvalidate-invalid');
                }
              },
              markGroupsInvalid: function(input, validationObject) {
                var groupName, groupValidationObject, i, len, matchUid, ref, results;
                ref = validationObject.$groups;
                results = [];
                for (i = 0, len = ref.length; i < len; i++) {
                  groupName = ref[i];
                  groupValidationObject = $scope.$validation[groupName];
                  if (groupValidationObject == null) {
                    continue;
                  }
                  matchUid = "[mf-validate-uid='" + groupValidationObject.$uid + "']";
                  if (!input.is(':visible') && !input.parents(".nav-tabs .active " + matchUid).length) {
                    groupValidationObject.$invalid = true;
                    groupValidationObject.$errors = ['Click here to address errors.'];
                    results.push(this.markElementValidity(groupValidationObject));
                  } else {
                    results.push(void 0);
                  }
                }
                return results;
              },
              validate: function(setAllDirty) {
                var promise;
                if (setAllDirty == null) {
                  setAllDirty = false;
                }
                $http.defaults.headers.common['PretendValidate'] = true;
                promise = this.save(setAllDirty);
                delete $http.defaults.headers.common['PretendValidate'];
                return promise;
              },
              hasDirtyErrors: function(filter) {
                var name, obj, ref, ref1;
                if (filter == null) {
                  filter = void 0;
                }
                if (filter === void 0) {
                  ref = $scope.$validation;
                  for (name in ref) {
                    obj = ref[name];
                    if (obj.$errors.length > 0 && obj.$dirty) {
                      return true;
                    }
                  }
                  return false;
                }
                ref1 = $scope.$validation;
                for (name in ref1) {
                  obj = ref1[name];
                  if ((name === filter || obj.$groups.indexOf(filter) >= 0) && obj.$errors.length > 0 && obj.$dirty) {
                    return true;
                  }
                }
                return false;
              },
              registerInput: function(input, name, ngModel) {
                var debounced, inputScope, inputWithAddons, pixels, placementAttr, topLevelElement, uid, wrapper;
                if (name == null) {
                  name = void 0;
                }
                if (ngModel == null) {
                  ngModel = void 0;
                }
                topLevelElement = input.closest('[mf-validate]');
                name = input.attr('name') || name || input.attr('ng-model') || input.attr('mf-validate-model');
                inputScope = input.scope();
                if (inputScope.$select != null) {
                  inputScope = inputScope.$parent;
                }
                uid = Math.random().toString(36).substring(2);
                name = $interpolate(name)(inputScope);
                $scope.$validation[name] = {
                  $dirty: false,
                  $invalid: false,
                  $errors: [],
                  $uid: uid,
                  $groups: [],
                  $isGroup: this.element.find("[mf-validate-group='" + name + "']").length > 0
                };
                input.parentsUntil(this.element, '[mf-validate-group]').each(function(_, element) {
                  var group;
                  group = angular.element(element).attr('mf-validate-group');
                  return $scope.$validation[name].$groups.push($interpolate(group)(inputScope));
                });
                if (input.parents('.nav-tabs').length) {
                  inputWithAddons = input;
                  wrapper = angular.element("<div style='top: 0; left: 0;' mf-validate-uid='" + uid + "' ></div>");
                } else {
                  inputWithAddons = input.add(input.siblings('.add-on'));
                  pixels = _.sumBy(inputWithAddons, function(el) {
                    return $(el).outerWidth();
                  });
                  if (pixels === 0) {
                    wrapper = angular.element("<div style='top: 0; left: 0;' mf-validate-uid='" + uid + "' ></div>");
                  } else {
                    wrapper = angular.element("<div style='top: 0; left: 0; width: " + pixels + "px' mf-validate-uid='" + uid + "' ></div>");
                  }
                  debounced = debounce(function() {
                    var els;
                    els = topLevelElement.find("[mf-validate-uid=" + uid + "]").find('[mf-validate-repeat],[mf-validate-model],.add-on');
                    pixels = _.sumBy(els, function(el) {
                      return $(el).outerWidth();
                    });
                    if (pixels !== 0) {
                      return wrapper.width(pixels);
                    }
                  });
                  angular.element(window).on('resize', debounced);
                }
                $templateCache.put("mfValidate" + uid, "<span\n    ng-repeat=\"error in $validation['" + name + "'].$errors\"\n    ng-bind='error'\n></span>");
                wrapper.attr('uib-tooltip-template', "'mfValidate" + uid + "'");
                placementAttr = input.attr('mf-validate-tooltip-placement');
                wrapper.attr('tooltip-placement', placementAttr || this.tooltipPlacement);
                wrapper.attr('tooltip-trigger', 'focus mouseenter');
                wrapper.attr('tooltip-enable', "$validation['" + name + "'].$dirty &&\n$validation['" + name + "'].$invalid");
                wrapper.insertBefore(inputWithAddons);
                $compile(wrapper)(inputScope);
                wrapper.append(inputWithAddons);
                if ($scope.$validation[name].$isGroup) {
                  return;
                }
                ngModel = ngModel || input.attr('mf-validate-model') || input.attr('ng-model');
                if (input.attr('dont-watch') != null) {
                  return;
                }
                return inputScope.$watchCollection(ngModel, (function(_this) {
                  return function(newValue, oldValue) {
                    if (newValue !== oldValue && !(newValue !== newValue && oldValue !== oldValue)) {
                      $scope.$validation[name].$dirty = true;
                      _this.validate();
                      wrapper = topLevelElement.find("[mf-validate-uid=" + uid + "]");
                      return wrapper.parentsUntil(topLevelElement, '[mf-validate-group]').each(function(_, group) {
                        var groupName, ref;
                        groupName = angular.element(group).attr('mf-validate-group');
                        return (ref = $scope.$validation[groupName]) != null ? ref.$dirty = true : void 0;
                      });
                    }
                  };
                })(this));
              }
            };
          }
        ],
        link: function($scope, element, attrs, mfValidate) {
          var validateOnLoad;
          $scope.$validation = {};
          mfValidate.element = element;
          $scope.$validationController = mfValidate;
          validateOnLoad = $scope.$eval(element.attr('mf-validate-on-load'));
          mfValidate.tooltipPlacement = $scope.$eval(element.attr('mf-validate-tooltip-placement'));
          if (validateOnLoad) {
            return mfValidate.validate(true);
          }
        }
      };
    }
  ]);

}).call(this);
